import { Document, Page, Text, View } from "@react-pdf/renderer";
import amlReportStyles from "./Styles/amlReportStyles";
import Footer from "./Components/footer";
import Header from "./Components/header";
import theme from "../../../../css/WhiteLabelledDocuments/theme";
import PEP from "./Components/getPEPs";
import DatabaseVerification from "./Components/getDatabaseVerification";
import BioAndDocVerification from "./Components/getBioAndDocVerification";
import { formatCheckType } from "../CheckDetails/Utils/formatCheckType";
import VerificationIndicators from "./Components/getContras";
import MetaData from "./Components/getMetaData";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import getIconAndColorAndDecision from "./Utils/getIconColorDecision";

dayjs.extend(customParseFormat);

const AMLReport = ({
  check,
  portrait,
  docFront,
  docBack,
  state,
  pepSanReasonsByRef = {},
  experianResponseLive,
  overallOutcome,
}) => {
  const dob = state?.dob
    ? dayjs(state.dob, ["DD/MM/YYYY", dayjs.ISO_8601], true)
    : null;
  
  
    const meta = getIconAndColorAndDecision((overallOutcome || "").toLowerCase());
    const { icon, color, decision } = {
      icon: meta.icon,
      color: meta.color,
      decision: overallOutcome.toLocaleLowerCase() ,
    };

  // console.log(dob?.isValid() ? dob.format("DD MMM YYYY") : "Invalid Date");

  return (
    <Document>
      <Page size="A4" style={amlReportStyles.page}>
        <Header />
        <Footer state={state} />
        <View style={amlReportStyles.section}>
          <View style={amlReportStyles.headingRow}>
            <Text style={amlReportStyles.amlTextHeading}>
              Identity Verification Report
            </Text>
            <View
              style={{ flexDirection: "row", alignItems: "center", gap: 8 }}
            >
              {icon && icon}
              <Text
                style={{ ...amlReportStyles.amlDecisionTextSubheading, color }}
              >
                {overallOutcome || ""}
              </Text>
            </View>
          </View>
          <View
            style={{
              ...amlReportStyles.checkDetailsContainer,
              gap: 15,
              backgroundColor:
                overallOutcome === "Approved"
                  ? theme.colors.Green400
                  : overallOutcome === "Declined"
                    ? theme.colors.Red400
                    : theme.colors.Yellow400,
              borderWidth: 3,
              borderColor:
                overallOutcome === "Approved"
                  ? theme.colors.Success
                  : overallOutcome === "Declined"
                    ? theme.colors.error
                    : theme.colors.Warning,
            }}
          >
            <View
              style={{
                ...amlReportStyles.checkDetailsRow,
                alignItems: "center",
                justifyContent: "space-evenly",
                width: "100%",
              }}
            >
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    ...amlReportStyles.amlTextCaption,
                  }}
                >
                  Client Name
                </Text>
                <Text
                  style={{
                    ...amlReportStyles.amlTextSubheading,
                    color: theme.colors.Black,
                  }}
                >
                  {state?.name || ""}
                  {/* {check?.verification?.person?.firstName ? (
                    <>
                      {check?.verification?.person?.firstName}{" "}
                      {check?.verification?.person?.lastName}
                    </>
                  ) : (
                    <>{state?.name || ""}</>
                  )} */}
                </Text>
              </View>
              <View style={amlReportStyles.verticalDivider} />
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    ...amlReportStyles.amlTextCaption,
                  }}
                >
                  Client DOB
                </Text>
                <Text
                  style={{
                    ...amlReportStyles.amlTextSubheading,
                    color: theme.colors.Black,
                  }}
                >
                  {dob ? dob.format("DD MMM YYYY") : ""}
                </Text>
              </View>
              <View style={amlReportStyles.verticalDivider} />
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    ...amlReportStyles.amlTextCaption,
                  }}
                >
                  Check Type
                </Text>
                <Text
                  style={{
                    ...amlReportStyles.amlTextSubheading,
                    color: theme.colors.Black,
                  }}
                >
                  {formatCheckType(state?.checkType) || ""}
                </Text>
              </View>

              {/* <View style={amlReportStyles.verticalDivider} /> */}
              {/* <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    ...amlReportStyles.amlTextCaption,
                  }}
                >
                  Result
                </Text>
                <Text
                  style={{
                    ...amlReportStyles.amlTextSubheading,
                    color: theme.colors.Black,
                  }}
                >
                  {overallOutcome || ""}
                </Text>
              </View> */}
            </View>
            <View style={amlReportStyles.horizontalDivider} />
            <View
              style={{
                ...amlReportStyles.checkDetailsRow,
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              {" "}
              <View
                style={{
                  ...amlReportStyles.checkDetailsColumn,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    ...amlReportStyles.amlTextCaption,
                  }}
                >
                  Client Address
                </Text>
                <Text
                  style={{
                    ...amlReportStyles.amlTextSubheading,
                    color: theme.colors.Black,
                  }}
                >
                  {state?.fullAddress || ""}
                </Text>
              </View>
            </View>
          </View>
          {/* <View style={{ ...amlReportStyles.headingRow }}>
          </View> */}
        </View>
        {state?.forAdviser && (
          <View style={amlReportStyles.section}>
            <View style={{ ...amlReportStyles.infoContainer }}>
              <Text
                style={{
                  ...amlReportStyles.amlTextCaption,
                }}
              >
                This check was requested on behalf of {state?.forAdviser}.
              </Text>
            </View>
          </View>
        )}
        <View style={amlReportStyles.verticalSizeBox} />
        <BioAndDocVerification
          check={check}
          checkType={state?.checkType}
          portrait={portrait}
          docFront={docFront}
          docBack={docBack}
        />

        {/* <VerificationIndicators
          check={check}
          response={experianResponseLive || {}}
        /> */}

        {formatCheckType(state?.checkType) !== "PEP & Sanctions" && (
          <DatabaseVerification
            check={check}
            response={experianResponseLive || {}}
          />
        )}

        <PEP
          check={check}
          checkType={formatCheckType(state?.checkType)}
          response={
            experianResponseLive || state?.experianResponse?.response || {}
          }
          reasonsByRef={pepSanReasonsByRef}
          state={state}
        />

        <MetaData state={state} />
      </Page>
    </Document>
  );
};

export default AMLReport;
